module.exports = require("events");


//////////////////
// WEBPACK FOOTER
// external "events"
// module id = 152
// module chunks = 0